import { DOCUMENT, inject, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class IframeTools {
  private readonly document = inject<Document>(DOCUMENT);

  readonly isInIframe = !!new URLSearchParams(
    this.document.defaultView?.location.search
  ).get('from_iframe');
}
